import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
/**
 * Component renders "groupDashed" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFGroupDashedNodeFC = ({ data }) => {
    return (_jsx(Box, { "data-templateid": data.templateCode, border: "1px solid", borderStyle: 'dashed', style: data.style }));
};
export const RFGroupDashedNode = RFGroupDashedNodeFC;
//# sourceMappingURL=RFGroupDashedNode.js.map